﻿(function () {
    'use strict';

    var serviceId = 'common';

    angular
        .module('app.common')
        .factory(serviceId, common);

    common.$inject = ['$q', '$http', 'logger', 'config', 'localStorageService', '$translate', '$rootScope', '$location', '$state', 'configConstants'];

    function common($q, $http, logger, config, localStorageService, $translate, $rootScope, $location, $state, configConstants) {

        return {
            config: config,
            $q: $q,
            $http: $http,
            httpGet: httpGet,
            httpPost: httpPost,
            httpPostFile: httpPostFile,
            httpPostAuth: httpPostAuth,
            spinOn: spinOn,
            spinOff: spinOff,
            createCookie: createCookie,
            readCookie: readCookie,
            activateController: activateController,
            $broadcast: $broadcast,
            getPermissionByPage: getPermissionByPage,
            localStorageService: localStorageService,
            logger: logger,
        };

        function httpGet(uri) {
            processLoggedOut();

            var self = this;
            var deferred = self.$q.defer();
            showLoader();
            self.$http.get(uri)
                .then(function successCallback(response) {
                    deferred.resolve(response.data);
                    dismissLoader();
                }, function errorCallback(response) {
                    deferred.reject(queryFailed($rootScope.errorHttp));
                    dismissLoader();
                });
            return deferred.promise;
        }


        function httpPost(uri, model) {
            processLoggedOut();

            var self = this;
            var deferred = self.$q.defer();
            showLoader();
            self.$http.post(uri, model)
                .then(function successCallback(response) {
                    deferred.resolve(response.data);
                    dismissLoader();
                }, function errorCallback(response) {
                    deferred.reject(queryFailed($rootScope.errorHttp));
                    dismissLoader();
                });

            return deferred.promise;
        }

        function httpPostFile(uri, model, fileName) {
            processLoggedOut();

            var self = this;
            var deferred = self.$q.defer();
            showLoader();

            self.$http({
                url: uri,
                method: "POST",
                data: model,
                headers: { 'Content-type': 'application/json' },
                responseType: 'arraybuffer'
            }).then(function successCallback(response) {
                dismissLoader();
                var headers = response.headers();

                var filename = fileName;
                var contentType = headers['content-type'];
                var linkElement = document.createElement('a');

                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);

                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", filename);

                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });

                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }, function errorCallback(response) {
                dismissLoader();
                console.log(response);
            });
        }

        function httpPostAuth(uri, model, head) {
            processLoggedOut();

            var self = this;
            var deferred = self.$q.defer();

            self.$http.post(uri, model, head)
                .then(function successCallback(response) {
                    deferred.resolve(response.data);
                }, function errorCallback(response) {
                    deferred.reject(queryFailed($rootScope.errorHttp))
                });
            return deferred.promise;
        }

        function queryFailed(error) {
            if (error.status === 0) {
                logger.NotyError($translate.instant('error.http.0'));
                logger.debug($translate.instant('error.http.0'));
                error.info = $translate.instant('error.http.0');
            } else if (error.status == 401) {
                if (!error.info)
                    logger.NotyError($translate.instant('error.http.401'));
            } else if (error.status == 405) {
                logger.NotyError($translate.instant('error.http.405'));
                logger.debug('HTTP verb not supported [405] - Server Message:' + error.info);
            } else if (error.status == 500) {
                logger.NotyError($translate.instant('error.http.500'));
                logger.debug('Internal Server Error [500] - \n' + error.info);
                error.info = '';
            } else {
                if(!error.status || !error.status.data || !error.status.data.error_description){
                    logger.NotyError($translate.instant('error.http.unknow'));
                }
                logger.debug('Internal Server Error [Unknow] - \n' + error.info);
                error.info = '';
            }
            return error;
        }

        /*--------------------   Spinner Injection -------------------------*/
        function activateController(promises) {
            return $q.all(promises).then(function (eventArgs) {
                $broadcast(config.events.controllerActivateSuccess);
                return eventArgs;
            }, function (e) {
                if (e.info) {
                    logger.debug(e.info);
                    //toastr.error(e.info)
                } else {
                    toastr.error("Error en la llamada de datos");
                }
                //toastr.error("Error en la llamada de datos:" + e.info);
            });
        }

        function $broadcast() {
            return $rootScope.$broadcast.apply($rootScope, arguments);
        }

        function spinOn() {
            alert('spinOn');
            //$broadcast(config.events.controllerActivateInit);
        }

        function spinOff() {
            alert('spinOff');
            //$broadcast(config.events.controllerActivateSuccess);
        }

        function createCookie(name, value, days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }

        function readCookie(name) {
            var nameEQ = name + "=";
            var ca = document.cookie.split(';');
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
            }
            return null;
        }

        /*---------------------  Private Methods ---------------------------*/
        function processLoggedOut() {
            if (isLoggedOut()) {
                logOut();
            }
        }

        function isLoggedOut() {
            var authData = localStorageService.get('authorizationData');
            return !authData;
        }

        function logOut() {
            var latitude = localStorageService.get('latitude');
            var longitude = localStorageService.get('longitude');
            localStorageService.clearAll();
            localStorageService.set('latitude', latitude);
            localStorageService.set('longitude', longitude);     
            $location.path('/login');
            //window.location.reload(true);
        };
        function showLoader() {
            if ($(".custom-loader-div").length == 0) {
                $('body').prepend("<div class='custom-loader-div'><div class='custom-loader-image'/></div>");
                $('.custom-loader-div').attr("data-loadernumber", 0);
            }

            var loadernumber = $('.custom-loader-div').attr("data-loadernumber");
            $('.custom-loader-div').attr("data-loadernumber", ++loadernumber);

        }

        function dismissLoader() {
            var loadernumber = $('.custom-loader-div').attr("data-loadernumber");
            $('.custom-loader-div').attr("data-loadernumber", --loadernumber);

            if ($('.custom-loader-div').attr("data-loadernumber") == 0) {
                $(".custom-loader-div").remove();
            }
        }

        function getPermissionByPage(option)
        {
            var self = this;
            var authData = self.localStorageService.get('authorizationData');

            // Filtrar por operador y LimitedCarrier
            var operatorFilter = authData.userRole == configConstants.enums.userRoles.operator;
            operatorFilter = operatorFilter || authData.userRole == configConstants.enums.userRoles.limitedCarrier;

            if (operatorFilter) {
                // Filtrar por páginas GTI y GTO
                var pageFilter = option == configConstants.enums.pages.gateIn;
                pageFilter = pageFilter || option == configConstants.enums.pages.gateOut;

                if (pageFilter) {
                    var hashControlhide = {};
                    hashControlhide['consolidation'] = true;
                    hashControlhide['appointmentin'] = true;
                    hashControlhide['appointmentout'] = true;    
                    hashControlhide['addAppointment'] = true;
                    hashControlhide['viewReportAppointment'] = true;
                    hashControlhide['editAppointment'] = true;
                    hashControlhide['deleteAppointment'] = true;
                    hashControlhide['manageChecksForApptCreation'] = true;                    
                    hashControlhide['saveAppointment'] = true;                    
                    return hashControlhide;
                }                
            }
            return {};
        }
    }
})();